import Layout1 from '@/layout/Layout1'

export default [{
  path: '/generalledger',
  component: Layout1,
  children: [{
    path: 'category/:id',
    component: () => import('@/components/generalledger/maintenance/accountcategories/categoryEdit')
  }, {
    path: 'category',
    component: () => import('@/components/generalledger/maintenance/accountcategories/categoryList')
  }, {
    path: 'accountchart/:id',
    component: () => import('@/components/generalledger/maintenance/accountcharts/accountchartEdit')
  }, {
    path: 'accountchart',
    component: () => import('@/components/generalledger/maintenance/accountcharts/accountchartList')
  }, {
    path: 'currencysetupEdit/:id',
    component: () => import('@/components/generalledger/maintenance/currencysetups/currencysetupEdit')
  }, {
    path: 'currencysetupList',
    component: () => import('@/components/generalledger/maintenance/currencysetups/currencysetupList')
  }, {
    path: 'postingsettingEdit/:id',
    component: () => import('@/components/generalledger/maintenance/postingsettings/postingsettingEdit')
  }, {
    path: 'postingsettingList',
    component: () => import('@/components/generalledger/maintenance/postingsettings/postingsettingList')
  }, {
    path: 'periodsetupDTOEdit/:id',
    component: () => import('@/components/generalledger/maintenance/periodsetups/periodsetupDTOEdit')
  }, {
    path: 'periodsetupDTOList',
    component: () => import('@/components/generalledger/maintenance/periodsetups/periodsetupDTOList')
  }, {
    path: 'definitionheader/:id',
    component: () => import('@/components/generalledger/maintenance/accountdefinitionheaders/definitionheaderEdit')
  }, {
    path: 'definitionheader',
    component: () => import('@/components/generalledger/maintenance/accountdefinitionheaders/definitionheaderList')
  }, {
    path: 'formatsetup',
    component: () => import('@/components/generalledger/maintenance/accountformatsetups/formatsetupEdit')
  }, {
    path: 'batchentry/:id',
    component: () => import('@/components/generalledger/transaction/batchentries/batchentryEdit')
  }, {
    path: 'batchentry',
    component: () => import('@/components/generalledger/transaction/batchentries/batchentryList')
  }, {
    path: 'segment',
    component: () => import('@/components/generalledger/maintenance/segments/segmentMain')
  }, {
    path: 'glentry/:id',
    component: () => import('@/components/generalledger/transaction/glentry/glentryEdit')
  }, {
    path: 'glentry',
    component: () => import('@/components/generalledger/transaction/glentry/glentryList')
  }, {
    path: 'exchangerate/:id',
    component: () => import('@/components/generalledger/maintenance/currencyexchangerates/exchangerateEdit')
  }, {
    path: 'exchangerate',
    component: () => import('@/components/generalledger/maintenance/currencyexchangerates/exchangerateList')
  }]
}]
